module.exports = __webpack_public_path__ + "static/media/frankleest.7c7e3eb8.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/frankleest.webp
// module id = 525
// module chunks = 0